{
  "CreateAccount": {
    "mainHeader": "Hello.",
    "invitation": "{{invitedBy}} has invited you to join this workspace"
  },
  "RegisterUserPanel": {
    "header": "Create Account",
    "emailLabel": "Email",
    "passwordLabel": "Set a password",
    "passwordPlaceholder": "Keep it secret",
    "confirmPasswordLabel": "Confirm password",
    "confirmPasswordPlaceholder": "Keep it safe",
    "continueButton": "Continue",
    "errors": {
      "passwordRequired": "Password is required",
      "passwordMinLength": "Password must be at least 8 characters",
      "passwordUpperCase": "Your password should have at least 1 upper case character",
      "confirmPasswordRequired": "Please confirm your password",
      "passwordsMismatch": "Passwords do not match"
    }
  },
  "CreateProfile": {
    "header": "About you",
    "subheader": "Tell us a few things about yourself to get started"
  },
  "CreateProfilePanel": {
    "header": "Create profile",
    "firstNameLabel": "First Name",
    "firstNamePlaceholder": "First name",
    "lastNameLabel": "Last Name",
    "lastNamePlaceholder": "Last name",
    "continueButton": "Continue",
    "errors": {
      "firstNameRequired": "First name is required",
      "lastNameRequired": "Last name is required"
    }
  },
  "CompletedRegistration": {
    "headerWithName": "{{firstName}}, you're all set up!",
    "header": "You're all set up!",
    "description": "A warm hello from Atellio. We're a talent management platform that empowers companies to manage their own talent network.",
    "letsGo": "Take me there"
  },
  "ArrivalBoard": {
    "scheduleBoard": "Schedule Board",
    "page": "Page",
    "name": "Name",
    "location": "Location",
    "role": "Role"
  }
}
